import {BarChart3, CreditCardIcon, History, Trophy} from "lucide-react";

export const ICON_SIZE = 27

export const sidebarMenus = [
    {
        labelKey: "navMatches",
        route: "/analyze",
        icon: <BarChart3 style={{fontSize: ICON_SIZE}}/>
    }, {
        labelKey: "navCompetitions",
        route: "/competitions",
        icon: <Trophy style={{fontSize: ICON_SIZE}}/>
    }, {
        labelKey: "navHistory",
        route: "/history",
        icon: <History style={{fontSize: ICON_SIZE}}/>
    }, {
        labelKey: "navPricing",
        route: "/pricing",
        icon: <CreditCardIcon style={{fontSize: ICON_SIZE}}/>
    }]